import cx from 'clsx';
import React from 'react';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/core/Skeleton';
import { Links } from '../../../components/links';
import { useStyles } from '../../../models/styles/desktop';
import { MButton } from '../../../@material-extend/Buttons/MButton';
import { MainTabs } from './MainTabs';
import { LoginMenu } from './LoginMenu';
import { DesktopLangMenu } from './DesktopLangMenu';
export var DesktopHeader = function DesktopHeader(_ref) {
  var proPlanId = _ref.proPlanId,
      queryPath = _ref.queryPath,
      isLogin = _ref.isLogin,
      isLoading = _ref.isLoading,
      isCheckoutPage = _ref.isCheckoutPage,
      currentLanguageLabel = _ref.currentLanguageLabel,
      onAction = _ref.onAction,
      user = _ref.user,
      Link = _ref.Link,
      changeLang = _ref.changeLang,
      intl = _ref.intl,
      additionalMenu = _ref.additionalMenu,
      clientName = _ref.clientName,
      styles = _ref.styles,
      profile = _ref.profile;

  var _a, _b, _c, _d;

  var classes = useStyles(styles);
  var initial = isLogin ? user.name.charAt(0).toUpperCase() : '';
  if (isCheckoutPage) return React.createElement(Box, {
    component: 'div',
    className: classes.navmenu,
    display: {
      xs: 'none',
      lg: 'block'
    }
  });
  if (isLogin) return React.createElement(Box, {
    component: 'div',
    sx: {
      width: '100%',
      display: 'none',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '@media (min-width: 1159px)': {
        display: 'flex'
      }
    }
  }, React.createElement(MainTabs, {
    intl: intl,
    Link: Link,
    user: user,
    isLogin: isLogin,
    clientName: clientName
  }), React.createElement(Box, {
    sx: {
      gap: '15px',
      width: 'auto',
      height: '44px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, currentLanguageLabel && React.createElement(DesktopLangMenu, {
    changeLang: changeLang,
    currentLanguageLabel: currentLanguageLabel
  }), React.createElement(LoginMenu, {
    onAction: onAction,
    styles: classes,
    user: user,
    intl: intl,
    additionalMenu: additionalMenu,
    profile: profile,
    initial: initial
  }), queryPath !== '/free-trial' && ((_a = user === null || user === void 0 ? void 0 : user.trial) === null || _a === void 0 ? void 0 : _a.on_trial) === false && ((_b = user === null || user === void 0 ? void 0 : user.subscription) === null || _b === void 0 ? void 0 : _b.sub_category) === 'free' && currentLanguageLabel !== 'jp' ? React.createElement(Links, {
    Link: Link,
    to: '/free-trial'
  }, React.createElement("div", {
    className: classes.trialButton
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'try_for_free',
    defaultMessage: 'Try for free'
  }))) : !queryPath.includes('/user/checkout') && ((_c = user === null || user === void 0 ? void 0 : user.trial) === null || _c === void 0 ? void 0 : _c.on_trial) === false && ((_d = user === null || user === void 0 ? void 0 : user.subscription) === null || _d === void 0 ? void 0 : _d.sub_category) === 'basic' && currentLanguageLabel !== 'jp' ? React.createElement(Links, {
    Link: Link,
    to: '/user/checkout?q=' + proPlanId
  }, React.createElement("div", {
    className: classes.trialButton,
    style: {
      display: 'inline-flex'
    }
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'try_pro',
    defaultMessage: 'Try Pro'
  }), React.createElement("img", {
    width: '18px',
    height: '18px',
    alt: 'Designs.ai Pro crown',
    className: classes.crownIcon,
    src: 'https://assets.designs.ai/images/procrown.svg'
  }))) : ''));
  return React.createElement(Box, {
    component: 'div',
    sx: {
      width: '100%',
      marginLeft: 0,
      display: 'none',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '@media (min-width: 1159px)': {
        display: 'flex'
      }
    },
    className: classes.navmenu
  }, React.createElement(MainTabs, {
    user: user,
    intl: intl,
    Link: Link,
    isLogin: isLogin,
    clientName: clientName
  }), React.createElement(Box, {
    component: 'div',
    sx: {
      gap: '15px',
      width: 'auto',
      height: '44px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, currentLanguageLabel && React.createElement(DesktopLangMenu, {
    changeLang: changeLang,
    currentLanguageLabel: currentLanguageLabel
  }), queryPath !== '/free-trial' && currentLanguageLabel !== 'jp' && !queryPath.includes('/user/checkout') ? React.createElement(Links, {
    Link: Link,
    to: '/free-trial'
  }, React.createElement(Box, {
    className: classes.trialButton
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'try_for_free',
    defaultMessage: 'Try for free'
  }))) : '', isLoading ? React.createElement(Skeleton, {
    variant: 'circular',
    width: 40,
    height: 40
  }) : React.createElement(MButton, {
    className: cx(classes.loginButton),
    onClick: function onClick() {
      return onAction({
        action: 'login'
      });
    }
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'sign_in',
    defaultMessage: 'Sign in'
  }))));
};